import { cn } from "./cn";
import { CalendarIcon } from "./icons/CalendarIcon";
import SectionCard from "./section-card";

const NEUTRAL_500 = "#767c83";

const EventDateCard = ({
  dates,
  startLabel,
  endLabel,
  dateLabel,
  timeZone,
  titleFont,
  textFont,
}) => {
  const groups = (dates || [])
    .map((entry, index) => {
      const rows = [];
      if (entry.start)
        rows.push({ key: "start", label: startLabel, ...entry.start });
      if (entry.end) rows.push({ key: "end", label: endLabel, ...entry.end });
      /* Stable key from the formatted dates so rows keep their identity; the
       * index disambiguates otherwise-identical entries (e.g. a repeated day). */
      const key = `${entry.start?.date ?? ""}|${entry.end?.date ?? ""}|${index}`;
      return { key, rows };
    })
    .filter((group) => group.rows.length > 0);

  if (groups.length === 0) return null;

  return (
    <SectionCard className="flex flex-col gap-4 px-2 py-3" id="eventDate">
      <div className="flex items-center gap-3.5 pb-4 shadow-[inset_0_-1px_0_0_rgb(0_0_0_/_0.05)]">
        <div className="bg-event-55 flex h-10 w-10 items-center justify-center rounded rtl:ml-2">
          <CalendarIcon size={24} color={NEUTRAL_500} />
        </div>
        <span
          className="text-xl leading-5 font-normal text-event-900"
          style={titleFont ? { fontFamily: titleFont } : undefined}
        >
          {dateLabel}
        </span>
      </div>
      <div className="flex flex-col gap-4">
        {groups.map((group, groupIndex) => (
          <div
            key={group.key}
            className={cn(
              "flex flex-col gap-4",
              groupIndex < groups.length - 1 &&
                "pb-4 shadow-[inset_0_-1px_0_0_rgb(0_0_0_/_0.05)]",
            )}
          >
            {group.rows.map((entry) => (
              <div key={entry.key} className="flex flex-col gap-1 text-start">
                <div className="flex flex-col gap-2">
                  <span
                    className="text-base leading-4.5 font-normal text-event-900"
                    style={textFont ? { fontFamily: textFont } : undefined}
                  >
                    {entry.label}
                  </span>
                  {entry.date && (
                    <span
                      className="text-[14px] leading-4 font-normal text-event-500"
                      style={textFont ? { fontFamily: textFont } : undefined}
                    >
                      {entry.date}
                    </span>
                  )}
                </div>
                {entry.time && (
                  <div className="flex gap-4 text-[14px] leading-4 font-normal text-event-500">
                    <span
                      style={textFont ? { fontFamily: textFont } : undefined}
                    >
                      {entry.time}
                    </span>
                    {timeZone && (
                      <span
                        style={textFont ? { fontFamily: textFont } : undefined}
                      >
                        {timeZone}
                      </span>
                    )}
                  </div>
                )}
              </div>
            ))}
          </div>
        ))}
      </div>
    </SectionCard>
  );
};

export default EventDateCard;
